//Vote model

export class Vote {

    public createdOn: any = null;
    public createdBy: string = "";
    public moteKey = "";

    constructor(json: any = {}) {
        this.updateFromJson(json);
    }

    public updateFromJson(json: any): void {
        this.createdBy = json.createdBy || null;
        this.createdOn = json.createdOn || null;
        this.moteKey = json.moteKey || null;
    }

    public toJson() {
        return {
            createdOn: this.createdOn,
            createdBy: this.createdBy,
            moteKey: this.moteKey
        };
    }
}
